<script>
import AutocompleteMixin from "../../mixins/autocomplete";

export default {
    name: "user-crud",

    mixins: [
        AutocompleteMixin
    ],

    props: [
        'isUpdate',
        'councils',
        'roles',
        'userCouncils',
        'userData',
        'submitUrl',
        'userRoles',
        'updateRolesEndpoint'
    ],

    data() {
        return {
            userRequest: {
                email: '',
                password: '',
                password_confirmation: '',
                gender: '',
                first_name: '',
                middle_name: '',
                last_name: '',
                street: '',
                street_number: '',
                city: '',
                postcode: '',
                phone: '',
                councils: null,
                roles: null,
            },
            errors: {},
        };
    },

    mounted() {
        this.userRequest = this.userData ? JSON.parse(this.userData) : {
            email: '',
            password: '',
            password_confirmation: '',
            gender: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            street: '',
            street_number: '',
            city: '',
            postcode: '',
            phone: '',
            councils: '',
            roles: '',
        };

        let councils = JSON.parse(this.userCouncils);
        let roles = JSON.parse(this.userRoles);

        if (councils.length > 0) {
            if (roles.filter(el => el.name === 'contractor').length > 0) {
                this.userRequest.councils = councils.map(el => el['id']);
            } else {
                this.userRequest.councils = councils[0].id;
            }
        }

        this.userRequest.roles = JSON.parse(this.userRoles).map(i => i['id']);
    },

    methods: {
        submit() {
            this.errors = [];

            axios.post(this.submitUrl, {
                'email': this.userRequest.email,
                'current_password': this.userRequest.current_password,
                'password': this.userRequest.password,
                'password_confirmation': this.userRequest.password_confirmation,
                'gender': this.userRequest.gender,
                'first_name': this.userRequest.first_name,
                'middle_name': this.userRequest.middle_name,
                'last_name': this.userRequest.last_name,
                'street': this.userRequest.street,
                'street_number': this.userRequest.street_number,
                'city': this.userRequest.city,
                'postcode': this.userRequest.postcode,
                'phone': this.userRequest.phone,
                'councils': this.userRequest.councils
            }).then(res => {
                if (res.status === 200) {
                    sessionStorage.setItem("alert_type", "success");
                    sessionStorage.setItem("message", this.$gettext("User has been saved successfully"));

                    this.$root.$emit("show-flash-message");

                    window.location.reload();
                }
            }).catch(errors => {
                this.errors = JSON.parse(JSON.stringify(errors.response.data.errors));

                sessionStorage.setItem("alert_type", "danger");
                sessionStorage.setItem("message", this.$gettext("Something went wrong"));

                this.$root.$emit("show-flash-message");
            });
        },

        updateCouncil() {
            if (this.$root.user.roles[0].name === 'super admin') {
                this.userRequest.councils = [];
            } else {
                if (!this.userRequest.roles.includes(JSON.parse(this.roles).filter(el => el.name === 'contractor')[0].id)) {
                    this.userRequest.councils = JSON.parse(this.userCouncils).filter(el => el.pivot.is_default === 1)[0].id
                }
            }

            this.$forceUpdate()
        },

        updateRoles() {
            this.errors = [];

            axios.post(this.updateRolesEndpoint, {
                roles: this.userRequest.roles
            }).then(res => {
                if (res.status === 200) {
                    sessionStorage.setItem("alert_type", "success");
                    sessionStorage.setItem("message", this.$gettext("User has been saved successfully"));

                    this.$root.$emit("show-flash-message");

                    window.location.reload();
                }
            }).catch(errors => {
                this.errors = JSON.parse(JSON.stringify(errors.response.data.errors));

                sessionStorage.setItem("alert_type", "danger");
                sessionStorage.setItem("message", this.$gettext("Something went wrong"));

                this.$root.$emit("show-flash-message");
            });
        }
    }
};
</script>
